import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = () => {
  return (
    <section className="relative min-h-[85vh] bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/images/hero-family.jpg')`
    }}>
      <div className="container mx-auto px-4 py-8 h-full flex items-center">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center w-full">
          {/* Left Side - Paulette's Photo Section */}
          <div className="bg-white bg-opacity-95 rounded-lg shadow-2xl p-6">
            <img 
              src="/images/paulette-office.jpg" 
              alt="Paulette Abdullah" 
              className="w-36 h-36 rounded-full mx-auto mb-3 object-cover shadow-lg border-4 border-teal-600"
            />
            <h2 className="text-2xl font-bold text-teal-600 text-center mb-2">Paulette Abdullah</h2>
            <p className="text-center text-gray-700 font-semibold mb-1">Licensed Health Insurance Agent</p>
            <p className="text-center text-gray-600 italic mb-3">"Retired Federal Medicare Recovery Specialist"</p>
            <div className="flex items-center justify-center gap-2 mb-3">
              <Phone className="text-teal-600" size={20} />
              <a href="tel:734.209.6712" className="text-xl font-bold text-teal-600 hover:text-teal-700">
                734.209.6712
              </a>
            </div>
            <p className="text-center text-sm text-gray-600">
              TRUSTED. EXPERIENCED. LOCAL.<br/>
              OUR CLIENTS ARE TREATED LIKE FAMILY.
            </p>
          </div>

          {/* Right Side - Updated Content */}
          <div className="bg-white bg-opacity-95 rounded-lg shadow-2xl p-6">
            <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-5">
              Get your Medicare and<br />Health Insurance Options Here
            </h1>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <CheckCircle className="text-teal-600 flex-shrink-0 mt-1" size={28} />
                <p className="text-xl text-gray-700">Offer all Major Carriers</p>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle className="text-teal-600 flex-shrink-0 mt-1" size={28} />
                <p className="text-xl text-gray-700">Our Services are Free</p>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle className="text-teal-600 flex-shrink-0 mt-1" size={28} />
                <p className="text-xl text-gray-700">We Advocate for YOU</p>
              </div>
            </div>
            <div className="mt-6 space-y-3">
              <Button asChild className="w-full bg-teal-600 hover:bg-teal-700 text-white text-lg py-6">
                <Link to="/medicare-explained">Learn About Medicare</Link>
              </Button>
              <Button asChild className="w-full bg-teal-600 hover:bg-teal-700 text-white text-lg py-6">
                <Link to="/individual-family">Learn about Individual/Family Health Plans</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
